import { overheadTotal, productionOverheadLines } from './productionCostOverhead.js';

export function canSplitSimulation(simulation) {
  return simulation?.status === 'saved' && (simulation.items?.length || 0) > 1
    && !(simulation.production_orders?.length);
}

export function splitSimulationPreview(items = [], selectedIds = new Set()) {
  const summarize = (rows) => ({
    items: rows,
    articles: rows.length,
    quantity: rows.reduce((sum, item) => sum + Number(item.total_quantity || 0), 0),
    process: Number(rows.reduce((sum, item) => sum + Number(item.total_process_cost || 0), 0).toFixed(4)),
    material: Number(rows.reduce((sum, item) => sum + Number(item.total_material_cost || 0), 0).toFixed(4)),
    total: Number(rows.reduce((sum, item) => sum + Number(item.total_cost || 0), 0).toFixed(4)),
    overhead: overheadTotal(productionOverheadLines(rows)),
  });
  return {
    remaining: summarize(items.filter(item => !selectedIds.has(item.id))),
    moving: summarize(items.filter(item => selectedIds.has(item.id))),
  };
}
